import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { useSelector, useDispatch } from "react-redux";
import { GetUserStatusTable } from "../../redux/Actions/userStatusService";
import UserstatusModal from "../../Modals/userstatusModal";
import Loader from "../../Loader";
import "../../Styles/table.css";
import moment from "moment/moment";

const ManagerManagement = () => {
  const dispatch = useDispatch();
  const [userStatusData, setuserStatusData] = useState([]);
  const [openUserModal, setopenUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { userData, loading } = useSelector((state) => state.userStatus);

  useEffect(() => {
    dispatch(GetUserStatusTable());
  }, []);

  useEffect(() => {
    if (userData && userData.length > 0) {
      const sortedData = userData
        .slice()
        .sort((a, b) => new Date(b?.createdDate) - new Date(a?.createdDate));
      const filteredData = sortedData.filter((item) => {
        const role = item?.role?.toLowerCase();
        const hasAdminOrManager = role === "admin" || role === "manager";
        return hasAdminOrManager;
      });

      setuserStatusData(filteredData);
    } else {
      setuserStatusData([]);
    }
  }, [userData]);

  const columns = [
    {
      name: "#",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return (
            <div
              style={{ width: "30px", fontSize: "13px", marginLeft: "20px" }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "Name",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return (
            <div style={{ marginLeft: "10px", width: "300px" }}>{value}</div>
          );
        },
      },
    },
    {
      name: "Email",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return (
            <div style={{ marginLeft: "10px", width: "300px" }}>{value}</div>
          );
        },
      },
    },
    {
      name: "Registration Date",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return (
            <div style={{ marginLeft: "10px", width: "250px" }}>{value}</div>
          );
        },
      },
    },
    {
      name: "ROLE",
      options: {
        customBodyRender: (value) => {
          return (
            <div
              style={{ marginLeft: "10px", fontSize: "13px", width: "150px" }}
            >
              {value}
            </div>
          );
        },
      },
    },

    {
      name: "Actions",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta) => {
          return <div style={{ width: "30px" }}></div>;
        },
      },
    },
  ];

  const data = userStatusData?.map((item, index) => {
    const { user, role, createdAt } = item;
    const formattedDate = moment(createdAt)?.format("DD/MM/YYYY");

    return [
      index + 1,
      user?.username || "N/A",
      user?.email || "N/A",
      formattedDate,
      role || "N/A"
    ];
  });

  const options = {
    filter: true,
    responsive: "standard",
    selectableRows: "none",
    rowsPerPage: 8,
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div style={{ marginTop: "20px", width: "100%" }}>
          <MUIDataTable
            data={data}
            options={options}
            columns={columns}
            style={{
              width: "1300px",
              marginLeft: "200px",
              border: "none",
            }}
          />
        </div>
      )}

      <UserstatusModal
        openUserModal={openUserModal}
        setopenUserModal={setopenUserModal}
        selectedUser={selectedUser}
      />
    </>
  );
};

export default ManagerManagement;
